// §120 (2026-10-03) SSS sayfası akordiyonu — sections/main-page.liquid (yalnız page.handle == 'faq') yükler, defer.
// İÇERİK YAPISI DEĞİŞMEZ: sayfa metni <h3>soru</h3> + ardından gelen cevap öğeleri (p, ul …) olarak kalır; FAQPage şeması
// sunucuda page.content'ten üretilir, bu betikten etkilenmez. Betik yalnız:
//   · h3'ün içeriğini bir <button aria-expanded aria-controls> içine alır (WAI-ARIA "heading + button" akordiyon kalıbı),
//   · cevap öğelerini hidden="until-found" ile gizler (Chrome'da sayfa içi aramada bulunan cevap kendiliğinden açılır).
// Klavye: düğme doğal odaklanır, Enter/Space açar-kapatır. JS yoksa/çalışmazsa her şey açık, ince çizgili liste görünür.
(function () {
  var kok = document.querySelector('[data-sq-sss]');
  if (!kok || kok.classList.contains('sq-sss--hazir')) return;
  var sorular = kok.querySelectorAll('h3');
  if (sorular.length < 2) return;
  var BASLIK = /^H[1-3]$/;

  Array.prototype.forEach.call(sorular, function (h3, i) {
    var cevaplar = [];
    var n = h3.nextElementSibling;
    while (n && !BASLIK.test(n.tagName)) { cevaplar.push(n); n = n.nextElementSibling; }
    if (!cevaplar.length || h3.querySelector('button')) return;

    var dugme = document.createElement('button');
    dugme.type = 'button';
    dugme.className = 'sq-sss__soru';
    while (h3.firstChild) dugme.appendChild(h3.firstChild);
    h3.appendChild(dugme);
    h3.classList.add('sq-sss__baslik');

    var kimlikler = cevaplar.map(function (c, j) {
      if (!c.id) c.id = 'SqSss-' + i + '-' + j;
      c.classList.add('sq-sss__cevap');
      return c.id;
    });
    dugme.setAttribute('aria-controls', kimlikler.join(' '));

    var ayarla = function (acik) {
      dugme.setAttribute('aria-expanded', acik ? 'true' : 'false');
      h3.classList.toggle('is-acik', acik);
      cevaplar.forEach(function (c) {
        if (acik) c.removeAttribute('hidden');
        else c.setAttribute('hidden', 'until-found');
      });
    };
    ayarla(false);
    dugme.addEventListener('click', function () { ayarla(dugme.getAttribute('aria-expanded') !== 'true'); });
    cevaplar.forEach(function (c) { c.addEventListener('beforematch', function () { ayarla(true); }); });
  });

  kok.classList.add('sq-sss--hazir');
})();
